module.exports = __webpack_public_path__ + "img/E-mail bleu.cef4d9aa.svg";